import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

const FAQSection = ({ themeColors = {}, faqsData = [] }) => { // Default to empty array for faqsData
  // Define local constants with fallbacks for themeColors properties
  const backgroundDark = themeColors.backgroundDark || '#fafafa';
  const textPrimary = themeColors.textPrimary || '#1a1a1a';
  const primaryColor = themeColors.primary || '#F4C542';
  const textSecondary = themeColors.textSecondary || 'rgba(26, 26, 26, 0.7)';

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: backgroundDark }}> {/* Used local constant */}
      <Container>
        <Typography
          variant="h4"
          align="center"
          fontWeight={600}
          sx={{
            mb: { xs: 4, md: 6 },
            fontSize: { xs: '1.75rem', md: '2.125rem' },
            color: textPrimary // Used local constant
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={8}>
            {faqsData.map((faq, index) => ( // faqsData is now guaranteed to be an array
              <Accordion key={index} sx={{ mb: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: primaryColor }} />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <Typography variant="h6" fontWeight={600} sx={{ color: textPrimary }}> {/* Used local constant */}
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ color: textSecondary }}> {/* Used local constant */}
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
    
  );
};

export default FAQSection;
